import anchorScroll from '../util/anchorScroll';

export default {
  init() {
  },
  finalize() {
    anchorScroll('.component-page-hero .btn');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/careers.js